module.exports = __webpack_public_path__ + "static/img/whatsapp.681dd06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/whatsapp.svg
// module id = 1sdC
// module chunks = 0